import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/messaging";
import toast from "react-hot-toast";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
const firebaseConfig = {
  apiKey: "AIzaSyDnN4Ql-FrWLxEZlmEkkZAkPKDRB7Hbfls",
  authDomain: "techmicro-usa-admin.firebaseapp.com",
  projectId: "techmicro-usa-admin",
  storageBucket: "techmicro-usa-admin.appspot.com",
  messagingSenderId: "939332177835",
  appId: "1:939332177835:web:1c67c7625bc62387740cee",
  measurementId: "G-7Q2TDBPFQ5",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
export async function ResetUserPassword(email) {
  try {
    await firebase.auth().sendPasswordResetEmail(email);
    return { success: true };
  } catch (error) {
    return { success: false, message: error.message };
  }
}
export async function checkEmail(email) {
  let success = true;
  try {
    await firebase
      .auth()
      .fetchSignInMethodsForEmail(email)
      .then((res) => {
        if (res && res.length > 0) {
          success = true;
        } else {
          success = false;
        }
      })
      .catch(function (error) {
        success = false;
      });
  } catch (error) {
    success = false;
    console.error("Error:", error);
  }
  return success;
}
export async function signUp(email, password) {
  let success = true;
  await firebase
    .auth()
    .createUserWithEmailAndPassword(email, password)
    .then(async (user) => {
      success = user;
    })
    .catch(function (error) {
      success = false;
    });
  return success;
}
export async function signIn(email, password) {
  let success = false;
  await firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then(async (user) => {
      success = { res: true, user: user.user.uid };
    })
    .catch(function (error) {
      success = { res: false, error: error.message };
    });
  return success;
}
export async function getUserById(userId, collection, callback) {
  try {
    if (!userId) {
      return {
        success: false,
        error: "User ID is missing , Please Create your account !",
      };
    }
    const userDoc = await firebase
      .firestore()
      .collection(collection)
      .doc(userId)
      .get();
    if (!userDoc.exists) {
      return { success: false, error: "User not found" };
    }
    const userData = userDoc.data();
    return { success: true, user: userData };
  } catch (error) {
    return { success: false, error: error.message };
  }
}
export async function getCurrentUserId() {
  var user = await firebase.auth().currentUser;
  if (user != null) {
    return user.uid;
  } else {
  }
}
export async function getCurrentUser() {
  var user = await firebase.auth().currentUser;
  if (user != null) {
    return user;
  } else {
  }
}
export async function logoutUser() {
  try {
    await firebase.auth().signOut();
    const themeColor = localStorage.getItem('themeColor');
    const secondaryColor = localStorage.getItem('secondaryColor');
    const layoutPreference = localStorage.getItem('layoutPreference');

    localStorage.clear();
    sessionStorage.clear();

    if (themeColor) localStorage.setItem('themeColor', themeColor);
    if (secondaryColor) localStorage.setItem('secondaryColor', secondaryColor);
    if (layoutPreference) localStorage.setItem('layoutPreference', layoutPreference);

    return true;
  } catch (error) {
    console.error("Error logging out: ", error);
    return false;
  }
}
export async function saveData(collection, doc, jsonObject) {
  let success = null;
  await firebase
    .firestore()
    .collection(collection)
    .doc(doc)
    .set(jsonObject, { merge: true })
    .then(async function () {
      success = true;
    })
    .catch(function (error) {
      success = false;
    });
  return success;
}

export const requestForToken = async (userId) => {
  try {
    if (typeof window === "undefined" || !('serviceWorker' in navigator) || !('Notification' in window)) {
      return;
    }

    // If notifications are blocked by the user/browser, exit gracefully
    if (Notification.permission === 'denied') {
      console.warn("Notifications are blocked in browser settings. Push notifications disabled.");
      return;
    }

    // If permission has not been decided yet, prompt for permission
    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        return;
      }
    }

    const messaging = getMessaging();
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log("Service Worker registered with scope:", registration.scope);

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY || "BK0dfsabY9Irh4AQjpqerjLIg6bUWR1cQiptBKk1lCxr_SaUCaJ2o1zR_yJW0xTK5f_yBIz0dE5Zy6qAa2uHpNM",
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      console.log("current token for client: ", currentToken);
      // Save token to user's document
      await firebase.firestore().collection("Users").doc(userId).update({
        fcmToken: currentToken
      });
      return currentToken;
    }
  } catch (err) {
    if (err?.code === 'messaging/permission-blocked' || err?.message?.includes('permission-blocked')) {
      console.warn("Notification permission was blocked by the browser.");
    } else {
      console.warn("Could not retrieve FCM token:", err?.message || err);
    }
  }
};

export const onMessageListener = (callback) => {
  const messaging = getMessaging();
  return onMessage(messaging, (payload) => {
    console.log("payload", payload);
    callback(payload);
  });
};

export async function addElementToNestedArray(collection, doc, array, obj) {
  let db = firebase.firestore();
  db.collection(collection)
    .doc(doc)
    .update({
      [array]: firebase.firestore.FieldValue.arrayUnion(obj),
    });
}
export async function removeItemfromArray(collection, doc, array, index) {
  let docRef = await firebase.firestore().collection(collection).doc(doc);
  let docData = await docRef.get();
  if (docData.exists && docData.data()[array][index] != undefined) {
    docRef.update({
      [array]: firebase.firestore.FieldValue.arrayRemove(
        docData.data()[array][index]
      ),
    });
  }
}
export const uploadProfileImage = (img, folderName) => {
  return new Promise((resolve, reject) => {
    const uploadTask = firebase
      .storage()
      .ref(`${folderName}/${img?.name}`)
      .put(img);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        alert(error.message);
        reject(error.message);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(`${folderName}`)
            .child(img?.name)
            .getDownloadURL();
          resolve(url);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
};
export async function uploadProductImage(img, sku) {
  return new Promise((resolve, reject) => {
    const extension = img?.name?.split(".").pop() || "png";
    const fileName = `${sku.toLowerCase()}.${extension}`;

    const uploadTask = firebase
      .storage()
      .ref(`product-images/${fileName}`)
      .put(img);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        alert(error.message);
        reject(error.message);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(`product-images`)
            .child(fileName)
            .getDownloadURL();
          resolve(url);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
}
export async function uploadImage(img, folderName) {
  return new Promise((resolve, reject) => {
    const uploadTask = firebase
      .storage()
      .ref(`${folderName}/${img?.name}`)
      .put(img);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        alert(error.message);
        reject(error.message);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(`${folderName}`)
            .child(img?.name)
            .getDownloadURL();
          resolve(url);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
}
export async function uploadBase64Labels(img, folderName, ext) {
  const id = uniqueID();
  return new Promise((resolve, reject) => {
    const uploadTask = firebase
      .storage()
      .ref(`${folderName}/${id}.${ext}`)
      .putString(img, "base64", { contentType: ext === "pdf" ? 'application/pdf' : `image/${ext}` });
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        alert(error.message);
        reject(error.message);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(`${folderName}`)
            .child(`${id}.${ext}`)
            .getDownloadURL();
          resolve(url);
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
}
export async function getAllOfCollection(collection) {
  let data = [];
  let querySnapshot = await firebase.firestore().collection(collection).get();
  querySnapshot.forEach(function (doc) {
    if (doc.exists) {
      data.push(doc.data());
    } else {
    }
  });
  return data;
}
export async function getAllOfCollectionCopy(collection) {
  let data = [];
  let querySnapshot = await firebase.firestore().collection(collection).get();
  querySnapshot.forEach(function (doc) {
    if (doc.exists) {
      if (doc.data()._id) {
      } else {
        console.log(doc.id)
        deleteDocument(collection, doc.id)
      }
      // data.push(doc.data());
    } else {
    }
  });
  return data;
}
export async function uploadMultipleImages(file, name) {
  try {
    const storageRef = firebase.storage().ref(name);
    await storageRef.put(file, { contentType: "image/jpeg" });
    const url = await storageRef.getDownloadURL();
    return url;
  } catch (err) {
    throw err;
  }
}
export async function uploadingImages(arr, folderName) {
  let images;
  try {
    if (arr?.length === 0) {
      toast.error("Upload your items photos.");
      return false;
    }
    let docId = uniqueID();
    let urls = await Promise.all(
      arr.map(async (item, index) => {
        let uri;
        if (typeof item?.image?.src === "object" && !undefined) {
          uri = await uploadMultipleImages(
            item.image.src,
            `${folderName}/${docId}/Image_${index}`
          );
        } else {
          return item?.image?.src || "";
        }
        return uri;
      })
    );
    images = urls;
    return images;
  } catch (error) {
    toast.error(error?.message);
  }
}
export async function uploadMultipleFiles(file, name) {
  try {
    const storageRef = firebase.storage().ref(name);
    console.log("Uploading file:", file);
    console.log("Upload path:", name);
    await storageRef.put(file, { contentType: "application/pdf" });
    const url = await storageRef.getDownloadURL();
    return url;
  } catch (err) {
    console.error("Error uploading file:", err);
    throw err;
  }
}
export async function uploadingFiles(arr, folderName) {
  let images;
  try {
    if (arr?.length === 0) {
      toast.error("Upload your Labels");
      return false;
    }
    let urls = await Promise.all(
      arr.map(async (item, index) => {
        let uri;
        if (item instanceof File) {
          uri = await uploadMultipleFiles(item, `${folderName}/${index}`);
        } else {
          return item || "";
        }
        return uri;
      })
    );
    images = urls;
    return images;
  } catch (error) {
    console.error("Error in uploading files:", error);
    toast.error(error?.message);
  }
}
export async function getData(collection, doc, objectKey) {
  if (objectKey === undefined) {
    return firebase
      .firestore()
      .collection(collection)
      .doc(doc)
      .get()
      .then(function (doc) {
        if (doc.exists) {
          return doc.data();
        } else {
          return false;
        }
      });
  } else {
    return firebase
      .firestore()
      .collection(collection)
      .doc(doc)
      .get()
      .then(function (doc) {
        if (doc.exists && doc.data()[objectKey] != undefined) {
          return doc.data()[objectKey];
        } else {
          return false;
        }
      });
  }
}
export const getDocById = async (collectionName, id) => {
  let docRef = await firebase?.firestore()?.collection(collectionName)?.doc(id);
  let document = await docRef?.get();
  if (document?.exists) return document?.data();
  else return {};
};
export async function getDocByKeyValue(collection, key, value) {
  let data = [];
  let querySnapshot = await firebase
    .firestore()
    .collection(collection)
    .where(key, "==", value)
    .get();
  await querySnapshot.forEach(function (doc) {
    data.push(doc.data());
  });
  return data;
}
export function uniqueID() {
  function chr4() {
    return Math.random().toString(16).slice(-4);
  }
  return (
    chr4() +
    chr4() +
    "-" +
    chr4() +
    "-" +
    chr4() +
    "-" +
    chr4() +
    "-" +
    chr4() +
    chr4() +
    chr4()
  );
}
export async function getDocWithIdByKeyValue(collection, key, value) {
  try {
    let data = [];
    let querySnapshot = await firebase
      .firestore()
      .collection(collection)
      .where(key, "==", value)
      .get();
    querySnapshot.forEach(function (doc) {
      let obj = doc.data();
      obj.id = doc.id;
      data.push(obj);
    });
    return data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
}
export async function getApplicantsData(applicants) {
  if (applicants?.length > 0) {
    try {
      const snapshot = await firebase
        .firestore()
        .collection("Users")
        .where(firebase.firestore.FieldPath.documentId(), "in", applicants)
        .get();
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      return data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
}
export const getAllFriends = async (collection, key, value) => {
  let querySnapshot = await firebase
    .firestore()
    .collection(collection)
    .where(key, "array-contains", value)
    .get();
  let data = await querySnapshot?.docs?.map((doc) => {
    return doc.data();
  });
  return data;
};
export async function addToArrayCustom(collection, doc, array, value) {
  let success = true;
  let docRef = await firebase.firestore().collection(collection).doc(doc);
  let docData = await docRef.get();
  if (docData.exists && docData.data()[array] != undefined) {
    docRef.update({
      [array]: firebase.firestore.FieldValue.arrayUnion(value),
      last_message_time: value.createdAt,
    });
    success = true;
  } else {
    success = false;
  }
  return success;
}
export async function updateArray(collection, doc, array, value, index) {
  let docRef = await firebase.firestore().collection(collection).doc(doc);
  let docData = await docRef.get();
  if (docData.exists && docData.data()[array][index] != undefined) {
    docRef
      .update({
        [array]: firebase.firestore.FieldValue.arrayRemove(
          docData.data()[array][index]
        ),
      })
      .then(async () => {
        let docRef1 = await firebase
          .firestore()
          .collection(collection)
          .doc(doc);
        let docData1 = await docRef1.get();
        if (docData1.exists && docData1.data()[array] != undefined) {
          docRef1.update({
            [array]: firebase.firestore.FieldValue.arrayUnion(value),
          });
        }
      });
  }
}
export const addToArray = async (collection, doc, array, value) => {
  let success = true;
  let docRef = await firebase.firestore().collection(collection).doc(doc);
  let docData = await docRef.get();
  if (docData.exists && docData.data()[array] != undefined) {
    docRef.update({
      [array]: firebase.firestore.FieldValue.arrayUnion(value),
    });
    success = true;
  } else {
    saveData(collection, doc, { [array]: [value] });
    success = false;
  }
  return success;
};
export async function deleteDocument(collection, doc, field) {
  let db = await firebase.firestore();
  return db.collection(collection)
    .doc(doc)
    .delete()
    .then(function () { })
    .catch(function (error) { });
}
export async function deleteAccount(userId) {
  let success = true;
  await firebase
    .auth()
    .currentUser.delete()
    .then(async (res) => {
      if (userId) {
        await firebase
          .firestore()
          .collection("Users")
          .doc(userId)
          .delete()
          .then(async () => {
            success = true;
          })
          .catch((error) => {
            success = error.message;
          });
      } else {
        toast.error("Something went wrong!");
      }
    })
    .catch((error) => {
      success = error.message;
    });
  return success;
}
export async function generateCustomID(collection) {
  const db = firebase.firestore();
  const counterRef = db.collection("counters").doc(collection);

  try {
    const newID = await db.runTransaction(async (transaction) => {
      const counterDoc = await transaction.get(counterRef);

      if (!counterDoc.exists) {
        transaction.set(counterRef, { currentID: 1 });
        return "1";
      }

      const currentID = Number(counterDoc.data()?.currentID) || 0;
      const nextID = currentID + 1;

      transaction.update(counterRef, { currentID: nextID });
      return nextID.toString();
    });

    return newID;
  } catch (error) {
    console.error("Error generating custom ID:", error);
    throw error;
  }
}

// export async function generateCustomID(collection) {
//   const db = firebase.firestore();
//   const counterRef = db.collection("counters").doc(collection);
//   try {
//     // Run an atomic transaction to increment the counter
//     const newID = await db.runTransaction(async (transaction) => {
//       const counterDoc = await transaction.get(counterRef);
//       if (!counterDoc.exists) {
//         // Initialize the counter if it doesn't exist
//         transaction.set(counterRef, { currentID: 1 });
//         return "1";
//       }
//       // Get the current ID and increment it
//       const currentID = counterDoc.data().currentID;
//       const newID = (currentID + 1).toString();
//       // Update the counter document with the new ID
//       transaction.update(counterRef, { currentID: currentID + 1 });
//       return newID;
//     });
//     console.log("✌️ New Custom ID:", newID);
//     return newID;
//   } catch (error) {
//     console.error("Error generating custom ID:", error);
//     throw error;
//   }
// }
// export async function uploadPDFBlob(pdfBlob, filename) {
//   if (pdfBlob) {
//     const storage = firebase.storage();
//     const storageRef = storage.ref();
//     const pdfRef = storageRef.child(filename);
//     await pdfRef.put(pdfBlob);
//     const downloadURL = await pdfRef.getDownloadURL();
//     return downloadURL;
//   } else {
//     console.log("PDF Blob not available.");
//   }
// }

export async function uploadPDFBlob(pdfBlob, filename) {
  if (!pdfBlob) {
    console.log("PDF Blob not available.");
    return null;
  }

  try {
    const storage = firebase.storage();
    const storageRef = storage.ref();

    const pdfRef = storageRef.child(`purchaseOrders/${filename}.pdf`);
    await pdfRef.put(pdfBlob);
    const downloadURL = await pdfRef.getDownloadURL();
    return downloadURL;
  } catch (error) {
    console.error("Error uploading PDF to Firebase Storage:", error);
    throw error;
  }
}
export async function uploadExcelFile(file) {
  return new Promise((resolve, reject) => {
    const id = Date.now();
    const fileName = `products-${id}`;
    const extension = file?.name?.split(".").pop() || "xlsx";
    const fullFileName = `${fileName}.${extension}`;
    const uploadTask = firebase
      .storage()
      .ref(`excel-sheets-products/${fullFileName}`)
      .put(file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        toast.error(error.message);
        reject(error.message);
      },
      async () => {
        try {

          const url = await firebase
            .storage()
            .ref(`excel-sheets-products`)
            .child(fullFileName)
            .getDownloadURL();
          resolve({ url, path: `excel-sheets-products/${fullFileName}` });
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
}

export async function uploadMadePCExcelFile(file) {
  return new Promise((resolve, reject) => {
    const fileName = file?.name || `Made_PC_Products_${Date.now()}.xlsx`;
    const storagePath = `madepc/${fileName}`;
    const uploadTask = firebase
      .storage()
      .ref(storagePath)
      .put(file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // tracking progress
      },
      (error) => {
        toast.error(error.message);
        reject(error);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(storagePath)
            .getDownloadURL();
          resolve({ url, path: storagePath });
        } catch (error) {
          console.error("Error getting download URL for Made PC file:", error);
          reject(error);
        }
      }
    );
  });
}


export async function uploadCategoryExcelFile(file) {
  return new Promise((resolve, reject) => {
    const id = Date.now();
    const fileName = `categories-${id}`;
    const extension = file?.name?.split(".").pop() || "xlsx";
    const fullFileName = `${fileName}.${extension}`;
    const uploadTask = firebase
      .storage()
      .ref(`excel-sheets-categories/${fullFileName}`)
      .put(file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress can be tracked here
      },
      (error) => {
        toast.error(error.message);
        reject(error.message);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(`excel-sheets-categories`)
            .child(fullFileName)
            .getDownloadURL();
          resolve({ url, path: `excel-sheets-categories/${fullFileName}` });
        } catch (error) {
          console.error("Error getting download URL:", error);
          reject(error);
        }
      }
    );
  });
}

export async function uploadGroupExcelFile(file, subfolder = "excel-sheets-groups") {
  return new Promise((resolve, reject) => {
    const id = Date.now();
    const rawName = file?.name ? file.name.replace(/[^a-zA-Z0-9._-]/g, "_") : `groups-${id}.xlsx`;
    const storagePath = `${subfolder}/${id}_${rawName}`;
    const uploadTask = firebase
      .storage()
      .ref(storagePath)
      .put(file);
    uploadTask.on(
      "state_changed",
      () => {},
      (error) => {
        toast.error(error.message || "Failed to upload file to storage.");
        reject(error);
      },
      async () => {
        try {
          const url = await firebase
            .storage()
            .ref(storagePath)
            .getDownloadURL();
          resolve({ url, path: storagePath });
        } catch (error) {
          console.error("Error getting download URL for group Excel file:", error);
          reject(error);
        }
      }
    );
  });
}

export const parseSpecs = (str) => {
  if (!str) return [];
  if (Array.isArray(str)) return str;
  if (typeof str === 'object') {
    return Object.entries(str).map(([key, value]) => ({ key, value }));
  }
  if (typeof str !== 'string') return [];

  const lines = str.split('\n');
  const specs = [];
  lines.forEach((line) => {
    const parts = line.split(':');
    if (parts.length >= 2) {
      const key = parts[0].trim();
      const value = parts.slice(1).join(':').trim();
      if (key) specs.push({ key, value });
    }
  });
  return specs;
};

export const stringifySpecs = (specs) => {
  if (!specs) return "";
  if (Array.isArray(specs)) {
    return specs.map(item => `${item.key}: ${item.value}`).join('\n');
  }
  if (typeof specs === 'object') {
    return Object.entries(specs)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
  }
  return specs || "";
};

export const formatAIResponseToHTML = (text) => {
  if (!text || typeof text !== "string") return text || "";

  let content = text
    .replace(/\r\n/g, "\n")
    .replace(/^(\*\*.*?\*\*:)/gm, "- $1");

  let formatted = content
    // Headings
    .replace(/^### (.*$)/gim, "<h3>$1</h3>")
    .replace(/^## (.*$)/gim, "<h2>$1</h2>")
    .replace(/^# (.*$)/gim, "<h1>$1</h1>")
    // Bold: **text**
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    // Italic: *text* (avoiding double asterisks)
    .replace(/(?<!\*)\*([^\*\n]+)\*(?!\*)/g, "<em>$1</em>")
    // Bullet points (supports -, *, •)
    .replace(/^[ \t]*[\-\*•]\s*(.*$)/gim, "<li>$1</li>")
    // Clean any stray trailing asterisks after words or colons (e.g. Harris:*)
    .replace(/([a-zA-Z0-9:])\*/g, "$1")
    // Tables
    .replace(/\|(.+)\|/g, (match) => {
      const cells = match.split("|").filter(x => x.trim() !== "");
      if (cells.length === 0 || match.includes("---")) return "";
      return `<tr>${cells.map(c => `<td>${c.trim()}</td>`).join("")}</tr>`;
    });

  // Structural wrapping
  formatted = formatted
    .replace(/((?:<li>.*?<\/li>\n?)+)/gs, "<ul>$1</ul>")
    .replace(/((?:<tr>.*?<\/tr>\n?)+)/gs, (match) => {
      return `<table border="1" style="width:100%; border-collapse: collapse; margin-bottom: 15px;">${match}</table>`;
    });

  // Final layout pass
  const blocks = formatted.split(/\n\n+/);
  formatted = blocks.map(block => {
    const trimmed = block.trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("<h") || trimmed.startsWith("<ul") || trimmed.startsWith("<table")) {
      return trimmed.replace(/>\n+</g, "><").replace(/\n/g, "<br/>");
    }
    return `<p>${trimmed.replace(/\n/g, "<br/>")}</p>`;
  }).join("");

  return formatted
    .replace(/<br\/><(li|tr|h\d|ul|ol|table|p|div)/g, "<$1")
    .replace(/<\/(li|tr|h\d|ul|ol|table|p|div)><br\/>/g, "</$1>");
};

export { firebaseConfig };
